export enum GiftCardsTypes {
  SET_LOADING_GIFT_CARDS = "SET_LOADING_GIFT_CARDS",
  LIST_GIFT_CARDS = "LIST_GIFT_CARDS",
  CREATE_GIFT_CARD = "CREATE_GIFT_CARD",
  DELETE_GIFT_CARD = "DELETE_GIFT_CARD",
}
